const getTodayOpeningHoursData = (workingSchedules = []) => {
  // Get the current date
  var today = new Date();

  // Get the day of the week (0-6, where Sunday is 0 and Saturday is 6)
  var dayOfWeek = today.getDay();

  // Adjust format (Monday = 1, Sunday = 7)
  var adjustedDay = dayOfWeek === 0 ? 7 : dayOfWeek;

  // Find the object for today
  const todayObject = workingSchedules.find((item) => item.dayNumber === adjustedDay);

  if (todayObject) {
    // You have the object for today
    return todayObject;
  } else {
    // Today's information is not available in the JSON data
    return null;
  }
};

export default getTodayOpeningHoursData;
